import dayjs from "dayjs";

export function formatRelativeTime(isoDate: string): string {
  const then = dayjs(isoDate);
  const now = dayjs();
  const diffMinutes = now.diff(then, "minute");

  if (diffMinutes < 1) return "Just now";
  if (diffMinutes < 60) return `${diffMinutes}m ago`;

  const diffHours = now.diff(then, "hour");
  if (diffHours < 24) return `${diffHours}h ago`;

  const diffDays = now.diff(then, "day");
  if (diffDays < 7) return `${diffDays}d ago`;

  return then.format("YYYY-MM-DD");
}
